export const oddsTokens = {
  oddsContainerPrimaryBgColor: '#FFFFFF',
  oddsSelectionBackgroundColor: '#f5f5f5',
  oddItemHoverColor: '#d9d9d9',
  oddsSelectionBorderColor: '#595959',
};

export const footballSingleEventTokens = {
  hiContrast: '#262626',
  sportEntityContainerPrimaryBgColor: '#FFFFFF',
  roundColor: '#8c8c8c',
  oddsSelectionBackgroundColor: '#f5f5f5',
  oddItemHoverColor: '#d9d9d9',
};

export const footballLineupsTokens = {
  footballFieldTone: '#d9d9d9',
  hiContrast: '',
  collapsibleBgColor: '',
  footballFieldLineColor: '',
  lineupsHeaderContainerBgColor: '',
  lineupsRowEvenBgColor: '',
  lineupsRowOddBgColor: '',
  lineupsSecondaryTextColor: '',
  mobileTabsSelectedBgColor: '',
  lineupsPrimaryBackgroundColor: '',
};

export const footballTeamH2HTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  progressOneBgColor: '',
  progressTwoBgColor: '',
  subHeaderBgColor: '',
};

export const footballTeamMatchH2HTokens = {
  hiContrast: '#262626',
  sportEntityContainerPrimaryBgColor: '#FFFFFF',
  rowBackgroundColor: '#FFFFFF',
  oddsContainerPrimaryBgColor: '#FFFFFF',
  progressOneBgColor: '#FF8502',
  progressTwoBgColor: '#8c8c8c',
  subHeaderBgColor: '#f0f0f0',
};

export const footballStandingsTokens = {
  primaryBackgroundColor: '',
  hiContrast: '',
  rowBackgroundColor: '',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballGroupStandingsTokens = {
  primaryBackgroundColor: '#f5f5f5',
  hiContrast: '#262626',
  rowBackgroundColor: '#FFFFFF',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballKnockoutStandingsTokens = {
  primaryBackgroundColor: '',
  hiContrast: '',
  rowBackgroundColor: '',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballTimelineTokens = {
  timelineBackgroundColor: '',
  secondaryHeaderTextColor: '',
  timelineTabBackgroundColor: '',
  tabTextColor: '',
};

export const footballMatchCenterTokens = {
  ...footballSingleEventTokens,
  ...footballLineupsTokens,
  ...footballTeamH2HTokens,
  ...footballStandingsTokens,
  ...footballGroupStandingsTokens,
  ...footballKnockoutStandingsTokens,
  ...footballTimelineTokens,
  ...oddsTokens,
  matchCenterPrimaryBackgroundColor: '#ffffff',
  tabBackgroundColor: '#f0f0f0',
  tabActiveTextColor: '#262626',
  tabActiveBackgroundColor: '#FF8400',
  tabMenuBorderColor: '#d9d9d9',
};

export const playoffTokens = {
  knockoutBgColor: '',
  knockoutHeaderBgColor: '',
  knockoutHeaderBorderColor: '',
  knockoutGameBgColor: '',
  knockoutGameBorderColor: '',
};
